import { CashReceiptModel } from "./cash-receipt.model";

export class CashReceiptPaymentModel {
  cashReceiptPaymentId: number = 0;
  cashReceiptId: number = 0;
  cashReceipt: CashReceiptModel = new CashReceiptModel();
  wayToPayId: number = 0;
  paidValue: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}